import { combineReducers } from '@reduxjs/toolkit'
import list from './list.store'

export const rootReducer = combineReducers({
  list,
})
